import axios from "axios";
import { useSelector } from "react-redux";

export const useApiRequest = () => {
  const user = useSelector((state: any) => state.user);

  const get = async <T>(url: string, options) => {
    const response = await axios
      .get<T>(`${process.env.REACT_APP_API_URL}${url}`, {
        headers: {
          Authorization: user.token,
        },
      })
      .catch(() => {});

    if (!response) return;

    return response?.data;
  };

  const deleteRequest = async <T>(url: string) => {
    const response = await axios
      .delete<T>(`${process.env.REACT_APP_API_URL}${url}`, {
        headers: {
          Authorization: user.token,
        },
      })
      .catch(() => {});

    if (!response) return;

    return response?.data;
  };

  const post = async <T>(url: string, data: any) => {
    const response = await axios
      .post<T>(`${process.env.REACT_APP_API_URL}${url}`, data, {
        headers: {
          Authorization: user.token,
        },
      })
      .catch(() => {});

    if (!response) return;

    return response?.data;
  };

  return { get, post, deleteRequest };
};
